import React, { useState } from 'react';

const Thirteenththeme = ({get_data}) => {
    const [cart, setCart] = useState([]);

    const addToCart = (item) => {
        setCart([...cart, item]);
        alert(`${item.service_name} added to cart!`);
    };

    return (
        <>
            <style>{`
        :root {
            /* Palette: Arctic Teal */
            --primary: #0d9488;       /* Teal 600 */
            --primary-dark: #0f766e;  /* Teal 700 */
            --primary-light: #2dd4bf; /* Teal 400 */
            --accent: #cffafe;        /* Cyan 100 */
            --bg-body: #f0fdfa;       /* Teal 50 */
            --bg-white: #ffffff;
            --text-dark: #134e4a;     /* Teal 900 */
            --text-muted: #334155;    /* Slate 700 */

            --font-head: 'Oswald', sans-serif;
            --font-body: 'Open Sans', sans-serif;

            --radius-sharp: 0px;
            --radius-soft: 8px;
            
            --shadow-float: 0 10px 15px -3px rgba(13, 148, 136, 0.1), 0 4px 6px -2px rgba(13, 148, 136, 0.05);
        }

        * {
            margin: 0;
            padding: 0;
            box-sizing: border-box;
        }

        body {
            font-family: var(--font-body);
            color: var(--text-dark);
            background-color: var(--bg-body);
            line-height: 1.6;
            overflow-x: hidden;
        }

        h1, h2, h3, h4, h5 {
            font-family: var(--font-head);
            color: var(--primary-dark);
            text-transform: uppercase;
            letter-spacing: 1px;
        }

        a {
            text-decoration: none;
            color: inherit;
            transition: 0.3s;
        }

        ul {
            list-style: none;
        }

        .container {
            max-width: 1200px;
            margin: 0 auto;
            padding: 0 24px;
        }

        .section {
            padding: 90px 0;
        }

        /* Buttons */
        .btn {
            display: inline-block;
            padding: 12px 28px;
            background-color: var(--primary);
            color: white;
            font-family: var(--font-head);
            text-transform: uppercase;
            letter-spacing: 1.5px;
            border: 2px solid var(--primary);
            border-radius: var(--radius-soft);
            cursor: pointer;
            transition: all 0.3s ease;
        }

        .btn:hover {
            background-color: transparent;
            color: var(--primary);
        }

        .btn-outline {
            display: inline-block;
            padding: 12px 28px;
            background-color: transparent;
            color: var(--primary);
            font-family: var(--font-head);
            text-transform: uppercase;
            letter-spacing: 1.5px;
            border: 2px solid var(--primary);
            border-radius: var(--radius-soft);
            cursor: pointer;
        }

        .btn-outline:hover {
            background-color: var(--primary);
            color: white;
        }

        /* Top Bar */
        .top-bar {
            background-color: var(--text-dark);
            color: var(--accent);
            padding: 10px 0;
            font-family: var(--font-body);
            font-size: 0.85rem;
        }

        .top-bar .container {
            display: flex;
            justify-content: flex-end;
            gap: 25px;
        }
        
        .top-bar i {
            margin-right: 5px;
            color: var(--primary-light);
        }

        /* Navbar */
        .navbar {
            background-color: var(--bg-white);
            border-bottom: 1px solid rgba(13, 148, 136, 0.1);
            padding: 20px 0;
            position: sticky;
            top: 0;
            z-index: 1000;
        }

        .navbar .container {
            display: flex;
            justify-content: space-between;
            align-items: center;
        }

        .brand {
            font-family: var(--font-head);
            font-size: 2rem;
            color: var(--primary);
            font-weight: 700;
        }

        .nav-links {
            display: flex;
            gap: 30px;
        }
        
        .nav-links a {
            font-family: var(--font-head);
            font-weight: 400;
            color: var(--text-dark);
            position: relative;
        }

        .nav-links a::after {
            content: '';
            position: absolute;
            left: 0;
            bottom: -5px;
            width: 0;
            height: 2px;
            background-color: var(--primary);
            transition: width 0.3s;
        }

        .nav-links a:hover::after {
            width: 100%;
        }

        /* Hero */
        .hero {
            position: relative;
            height: 90vh;
            background: linear-gradient(rgba(0,0,0,0.4), rgba(0,0,0,0.4)), url('https://images.unsplash.com/photo-1518531933037-91b2f5f229cc?ixlib=rb-1.2.1&auto=format&fit=crop&w=1920&q=80') center/cover;
            display: flex;
            align-items: center;
            justify-content: center;
            text-align: center;
            color: white;
            clip-path: polygon(0 0, 100% 0, 100% 90%, 50% 100%, 0 90%);
        }

        .hero h1 {
            color: white;
            font-size: 5rem;
            margin-bottom: 20px;
            text-shadow: 0 5px 15px rgba(0,0,0,0.2);
        }
        
        .hero p {
            font-size: 1.3rem;
            max-width: 700px;
            margin: 0 auto 40px;
            font-weight: 300;
        }

        /* Section Headers */
        .section-header {
            text-align: center;
            margin-bottom: 60px;
        }

        .section-tag {
            color: var(--primary);
            font-weight: 700;
            text-transform: uppercase;
            letter-spacing: 2px;
            font-size: 0.9rem;
            display: block;
            margin-bottom: 10px;
        }
        
        .section-header h2 {
            font-size: 3rem;
            position: relative;
            display: inline-block;
            margin-bottom: 0;
        }
        
        /* Services */
        .service-section {
            background-color: var(--bg-body);
        }

        .service-grid {
            display: grid;
            grid-template-columns: repeat(3, 1fr);
            gap: 20px;
        }

        .service-card {
            background: var(--bg-white);
            padding: 40px;
            text-align: center;
            border-top: 4px solid var(--primary);
            transition: 0.3s;
            box-shadow: 0 2px 10px rgba(0,0,0,0.03);
        }

        .service-card:hover {
            transform: translateY(-10px);
            box-shadow: var(--shadow-float);
        }

        .service-icon {
            width: 80px;
            height: 80px;
            margin: 0 auto 20px;
            border-radius: 50%;
            background-color: var(--accent);
            display: flex;
            align-items: center;
            justify-content: center;
            color: var(--primary);
            font-size: 2rem;
        }
        
        .service-icon img {
            width: 100%;
            height: 100%;
            border-radius: 50%;
            object-fit: cover;
        }

        .service-card h3 {
            margin-bottom: 15px;
            font-size: 1.5rem;
        }

        .service-card p {
            color: var(--text-muted);
            margin-bottom: 25px;
        }

        /* Products */
        .product-grid {
            display: grid;
            grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
            gap: 30px;
        }

        .product-card {
            background: var(--bg-white);
            position: relative;
            transition: 0.3s;
        }

        .product-card:hover {
            box-shadow: var(--shadow-float);
        }

        .product-img-wrapper {
            position: relative;
            overflow: hidden;
            height: 300px;
        }

        .product-img-wrapper img {
            width: 100%;
            height: 100%;
            object-fit: cover;
            transition: transform 0.5s;
        }

        .product-card:hover .product-img-wrapper img {
            transform: scale(1.1);
        }

        .product-overlay {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background: rgba(13, 148, 136, 0.8);
            opacity: 0;
            transition: 0.3s;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            gap: 15px;
        }

        .product-card:hover .product-overlay {
            opacity: 1;
        }

        .product-info {
            padding: 20px;
            text-align: center;
        }

        .product-info h3 {
            font-size: 1.1rem;
            margin-bottom: 5px;
        }

        .product-info .price {
            color: var(--primary);
            font-weight: 700;
        }

        /* Testimonials */
        .testimonials {
            background-color: var(--primary-dark);
            color: white;
            text-align: center;
        }

        .testimonials h2, .testimonials .section-tag {
            color: white;
        }
        
        .testimonials .section-tag {
            color: var(--primary-light);
        }

        .review-carousel {
            display: flex;
            gap: 40px;
            overflow-x: auto;
            padding: 20px 0;
            scrollbar-width: none;
        }

        .review-item {
            min-width: 400px;
            background: rgba(255, 255, 255, 0.1);
            backdrop-filter: blur(5px);
            padding: 40px;
            border-radius: var(--radius-soft);
            border: 1px solid rgba(255,255,255,0.1);
        }

        .review-body {
            font-style: italic;
            font-size: 1.1rem;
            margin-bottom: 20px;
            opacity: 0.9;
        }

        .review-author {
            font-weight: 700;
            color: var(--primary-light);
            text-transform: uppercase;
            letter-spacing: 1px;
        }

        /* Footer */
        footer {
            background-color: var(--bg-white);
            color: var(--text-dark);
            padding: 80px 0 20px;
            border-top: 5px solid var(--primary);
        }

        .footer-grid {
            display: grid;
            grid-template-columns: 2fr 1fr 1fr 1.5fr;
            gap: 40px;
            margin-bottom: 50px;
        }

        .footer-brand {
            font-family: var(--font-head);
            font-size: 2rem;
            font-weight: 700;
            color: var(--primary);
            display: block;
            margin-bottom: 20px;
        }

        .footer h4 {
            margin-bottom: 20px;
            font-size: 1.2rem;
        }

        .footer ul li {
            margin-bottom: 10px;
        }

        .footer a:hover {
            color: var(--primary);
            padding-left: 5px;
        }

        .social-bar {
            display: flex;
            gap: 15px;
            margin-top: 20px;
        }
        
        .social-bar a {
            color: var(--primary);
            font-size: 1.2rem;
            transition: 0.3s;
        }
        
        .social-bar a:hover {
            transform: scale(1.2);
            color: var(--primary-dark);
        }

        @media (max-width: 900px) {
            .hero h1 { font-size: 3rem; }
            .service-grid, .product-grid, .footer-grid { grid-template-columns: 1fr; }
            .nav-links, .top-bar { display: none; }
            .hero { clip-path: none; hieght: auto; padding: 100px 0; }
        }
            `}</style>

            <link href="https://fonts.googleapis.com/css2?family=Open+Sans:wght@300;400;600&family=Oswald:wght@300;400;700&display=swap" rel="stylesheet" />

            {/* Top Bar */}
            <div className="top-bar">
                <div className="container">
                    {get_data.business_location_name && <span><i>📍</i> {get_data.business_location_name}</span>}
                    {get_data.mobile && <span><i>📞</i> {get_data.mobile}</span>}
                    {get_data.email && <span><i>✉️</i> {get_data.email}</span>}
                </div>
            </div>

            {/* Navbar */}
            <nav className="navbar">
                <div className="container">
                    <a href="#" className="brand">{get_data.service_name}</a>
                    <div className="nav-links">
                        <a href="#">Home</a>
                        <a href="#about">About</a>
                        <a href="#services">Services</a>
                        <a href="#products">Products</a>
                        <a href="#reviews">Testimonials</a>
                        <a href="#contact">Contact</a>
                    </div>
                </div>
            </nav>

            {/* Hero */}
            <header className="hero">
                <div className="container">
                    <h1>Clean. Fresh. Modern.</h1>
                    <p>Experience the highest standards of purity and excellence with {get_data.service_name}. We bring a fresh perspective to everything we do.</p>
                    <div style={{display: 'flex', gap: '20px', justifyContent: 'center'}}>
                        <a href="#services" className="btn">Our Services</a>
                        <a href="#contact" className="btn-outline" style={{color: 'white', borderColor: 'white'}}>Contact Us</a>
                    </div>
                </div>
            </header>

            {/* About */}
            <section className="section" id="about">
                <div className="container">
                    <div style={{display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '50px', alignItems: 'center'}}>
                        <div>
                             <img src="https://images.unsplash.com/photo-1497215728101-856f4ea42174?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80" alt="Office" style={{width: '100%', borderRadius: '8px'}} />
                        </div>
                        <div>
                            <span className="section-tag">About Us</span>
                            <h2>We Innovate for You</h2>
                            <p style={{margin: '20px 0', color: 'var(--text-muted)'}}>
                                At {get_data.service_name}, we combine cutting-edge techniques with traditional values to deliver unparalleled results. Our team is dedicated to providing solutions that are as effective as they are efficient.
                            </p>
                            <a href="#contact" className="btn">Get Started</a>
                        </div>
                    </div>
                </div>
            </section>

            {/* Services */}
            <section className="section service-section" id="services">
                <div className="container">
                    <div className="section-header">
                        <span className="section-tag">What We Do</span>
                        <h2>Our Expertise</h2>
                    </div>
                    <div className="service-grid">
                        {get_data.categories && get_data.categories.map((item, index) => (
                            <div className="service-card" key={index}>
                                <div className="service-icon">
                                    {item.icon ? (
                                        <img 
                                            src={item.icon.startsWith('http') ? item.icon : `https://reliep-images.s3.ap-south-1.amazonaws.com/public/storage/${item.icon}`}
                                            alt={item.name}
                                        />
                                    ) : (
                                        <span>⚙</span>
                                    )}
                                </div>
                                <h3>{item.name}</h3>
                                <p>{item.description || 'Service details pending.'}</p>
                                <div style={{display: 'flex', gap: '10px', justifyContent: 'center'}}>
                                    <a href={`tel:${get_data.mobile}`} className="btn-outline" style={{padding: '8px 20px', fontSize: '0.8rem'}}>Call</a>
                                    <a href="#contact" className="btn" style={{padding: '8px 20px', fontSize: '0.8rem'}}>Enquiry</a>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

             {/* Products */}
            <section className="section" id="products">
                <div className="container">
                    <div className="section-header">
                        <span className="section-tag">Shop</span>
                        <h2>Featured Products</h2>
                    </div>
                    <div className="product-grid">
                        {get_data.product_services && get_data.product_services.map((item, index) => (
                            <div className="product-card" key={index}>
                                <div className="product-img-wrapper">
                                     <img 
                                        src={item.featured_image && item.featured_image.startsWith('http') ? item.featured_image : `https://reliep-snaps.s3.ap-south-1.amazonaws.com/featured/${item.featured_image}`} 
                                        alt={item.service_name}
                                    />
                                    <div className="product-overlay">
                                        <button onClick={() => addToCart(item)} className="btnbox" style={{background: 'white', color: 'var(--primary)', padding: '10px 20px', border: 'none', fontWeight: 'bold', cursor: 'pointer'}}>Add to Cart</button>
                                        <div style={{display: 'flex', gap: '10px'}}>
                                            <a href={`tel:${get_data.mobile}`} style={{background: 'transparent', border: '1px solid white', color: 'white', padding: '8px 15px', textTransform: 'uppercase', fontSize: '0.8rem'}}>Call</a>
                                            <a href="#contact" style={{background: 'transparent', border: '1px solid white', color: 'white', padding: '8px 15px', textTransform: 'uppercase', fontSize: '0.8rem'}}>Enquiry</a>
                                        </div>
                                    </div>
                                </div>
                                <div className="product-info">
                                    <h3>{item.service_name}</h3>
                                    {item.price && <div className="price">₹{item.price}</div>}
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

             {/* Testimonials */}
            <section className="section testimonials" id="reviews">
                <div className="container">
                    <div className="section-header">
                        <span className="section-tag">Feedback</span>
                        <h2>Client Stories</h2>
                    </div>
                    {get_data.review_ratings && get_data.review_ratings.length > 0 ? (
                        <div className="review-carousel">
                            {get_data.review_ratings.map((review, index) => (
                                <div className="review-item" key={index}>
                                    <div style={{marginBottom: '15px', color: 'var(--accent)'}}>
                                        {review.rating && <span>{'★'.repeat(Math.round(review.rating)) + '☆'.repeat(5 - Math.round(review.rating))}</span>}
                                    </div>
                                    <p className="review-body">"{review.review || 'Great service.'}"</p>
                                    <div className="review-author">- {review.user_name || 'Client'}</div>
                                </div>
                            ))}
                        </div>
                    ) : (
                        <p>No testimonials to display.</p>
                    )}
                </div>
            </section>

            {/* Footer */}
            <footer id="contact" className="footer">
                <div className="container">
                    <div className="footer-grid">
                        <div className="footer-col">
                            <span className="footer-brand">{get_data.service_name}</span>
                            <p>Delivering excellence since day one. Join us on our journey.</p>
                             <div className="social-bar">
                                {get_data.facebook && <a href={get_data.facebook}>Fb</a>}
                                {get_data.twitter && <a href={get_data.twitter}>Tw</a>}
                                {get_data.instagram && <a href={get_data.instagram}>Ig</a>}
                            </div>
                        </div>
                        <div className="footer-col">
                            <h4>Quick Links</h4>
                            <ul>
                                <li><a href="#">Home</a></li>
                                <li><a href="#about">About</a></li>
                                <li><a href="#services">Services</a></li>
                                <li><a href="#products">Products</a></li>
                            </ul>
                        </div>
                        <div className="footer-col">
                            <h4>Offering</h4>
                            <ul>
                                <li><a href="#services">All Services</a></li>
                                <li><a href="#products">Store</a></li>
                            </ul>
                        </div>
                        <div className="footer-col">
                            <h4>Contact Us</h4>
                            <ul>
                                <li>{get_data.business_location_name}</li>
                                <li>{get_data.email}</li>
                                <li>{get_data.mobile}</li>
                            </ul>
                        </div>
                    </div>
                    <div style={{textAlign: 'center', borderTop: '1px solid #e2e8f0', paddingTop: '20px', color: '#64748b'}}>
                        &copy; {new Date().getFullYear()} {get_data.service_name}. All Rights Reserved.
                    </div>
                </div>
            </footer>
        </>
    );
};

export default Thirteenththeme;
